import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface SendLogItem {
  wamid?: string;
  action?: string;
  to: string;
  from_number_id?: string | null;
  delivery_status?: 'sent' | 'delivered' | 'read' | 'failed';
  payload?: { body?: string; text?: { body?: string }; template_name?: string; [key: string]: unknown };
  errors?: Array<{ code?: number; title?: string; message?: string }>;
  timestamp: number;
  status_updated_at?: number;
}

type QueryResponse = {
  status: number;
  data: {
    statuses: SendLogItem[];
    total_count: number;
    limit: number;
    offset: number;
  };
};

export const createListStatusesKey = (additional: any[] = []) => [
  'list-statuses',
  ...additional,
];

export const useListStatusesQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while listing the delivery status log',
    endpoint: `/api/admin/whatsapp/statuses`,
  });

  return useQuery({
    queryKey: createListStatusesKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};
